<template>
  <!-- Acheive you Goals  -->
  <section class="home-five-goals">
    <div class="container">
      <div class="row align-items-center justify-content-center row-gap-4">
        <!-- Col -->
        <div class="col-xl-3 col-lg-12 col-md-12" data-aos="fade-down">
          <div class="acheive-goals-main">
            <h2>Capai Target Kompetensi Anda</h2>
          </div>
        </div>
        <!-- /Col -->

        <!-- Col -->
        <div class="col-xl-3 col-lg-4 col-md-4 col-12" data-aos="fade-down">
          <div class="acheive-goals">
            <div class="acheive-elips-one">
              <img src="@/assets/img/icon/ellipse-1.svg" alt="Img" />
            </div>
            <div class="acheive-goals-content text-center course-count ms-0">
              <h4>
                <span class="counterUp"
                  ><vue3-autocounter
                    class="counter"
                    ref="counter"
                    :startAmount="100"
                    :delay="3"
                    :endAmount="500"
                    :duration="5"
                    :autoinit="true"
                /></span>+
              </h4>
              <p>Total Instrukur Aktif</p>
            </div>
          </div>
        </div>
        <!-- /Col -->

        <!-- Col -->
        <div class="col-xl-3 col-lg-4 col-md-4 col-12" data-aos="fade-down">
          <div class="acheive-goals">
            <div class="acheive-elips-two">
              <img src="@/assets/img/icon/ellipse-2.svg" alt="Img" />
            </div>
            <div class="acheive-goals-content text-center course-count ms-0">
              <h4>
                <span class="counterUp"
                  ><vue3-autocounter
                    class="counter"
                    ref="counter"
                    :startAmount="10"
                    :delay="3"
                    :endAmount="100"
                    :duration="5"
                    :autoinit="true"
                /></span>+
              </h4>
              <p>Total Modul Pelatihan</p>
            </div>
          </div>
        </div>
        <!-- /Col -->

        <!-- Col -->
        <div class="col-xl-3 col-lg-4 col-md-4 col-12" data-aos="fade-down">
          <div class="acheive-goals">
            <div class="acheive-elips-three">
              <img src="@/assets/img/icon/ellipse-3.svg" alt="Img" />
            </div>
            <div class="acheive-goals-content text-center course-count ms-0">
              <h4>
                <span class="counterUp"
                  ><vue3-autocounter
                    class="counter"
                    ref="counter"
                    :startAmount="1"
                    :delay="3"
                    :endAmount="15"
                    :duration="5"
                    :autoinit="true"
                /></span>+
              </h4>
              <p>Kategori Keahlian</p>
            </div>
          </div>
        </div>
        <!-- /Col -->
      </div>
    </div>
  </section>
  <!-- /Acheive you Goals  -->
</template>
